import { random } from "gsap";

export const initDOMManipulation = () => {
	tweakReviews();
};

const tweakReviews = () => {
	const reviewCards = document.querySelectorAll(".sb-post-item-wrap");
	if (!reviewCards) return;
	const totalCardNumber = reviewCards.length;
	const halfCardNumber = Math.floor(totalCardNumber / 2);

	reviewCards.forEach((reviewCard, index) => {
		// entrance scroll anims
		reviewCard.setAttribute("data-aos", "flip-up");
		reviewCard.setAttribute("data-aos-duration", "1000");
		reviewCard.setAttribute("data-aos-offset", `-500`);

		// wrapping
		const reviewCardParentDiv = document.createElement("div");
		reviewCardParentDiv.classList.add("review-card-container", "rellax");
		const originalParent = reviewCard.parentNode;
		originalParent.insertBefore(reviewCardParentDiv, reviewCard);
		reviewCardParentDiv.appendChild(reviewCard);
		reviewCardParentDiv.setAttribute("data-rellax-percentage", "0.5");

		// parallaxing
		const slowSpeed = Math.random() * 0 + 0.5;
		const fastSpeed = Math.random() * 2 + 1;
		const scrollSpeed = index < halfCardNumber ? slowSpeed : fastSpeed;
		reviewCardParentDiv.setAttribute("data-rellax-speed", "0");
		reviewCardParentDiv.setAttribute("data-rellax-desktop-speed", scrollSpeed);
	});

	repositionReviewSectionTitle();
	window.addEventListener("resize", repositionReviewSectionTitle);
};

const repositionReviewSectionTitle = () => {
	const breakpoint = 1200;
	const sectionTitle = document.querySelector(".testimonials-section .section-title-container");
	const reviewCardContainers = document.querySelectorAll(".sb-feed-posts .review-card-container");
	if (!sectionTitle || !reviewCardContainers || reviewCardContainers.length < 2) return;

	if (window.innerWidth > breakpoint && !document.querySelector(".sb-feed-posts .section-title-container")) {
		sectionTitle.parentNode.removeChild(sectionTitle);
		reviewCardContainers[1].parentNode.insertBefore(sectionTitle, reviewCardContainers[1]);
	}
	if (window.innerWidth <= breakpoint && document.querySelector(".sb-feed-posts .section-title-container")) {
		sectionTitle.parentNode.removeChild(sectionTitle);
		// put it back as the first child of the .testimonials-section
		const testimonialsSectionContainer = document.querySelector(".testimonials-section .container");
		if (testimonialsSectionContainer) {
			testimonialsSectionContainer.insertBefore(sectionTitle, testimonialsSectionContainer.firstChild);
		}
	}
};
